import React from 'react';
import { AutoComplete } from 'antd';
import UserAvatarInfo from '../user-avatar-info/user-avatar-info';
import { AutoCompleteProps } from 'antd/lib/auto-complete';
import _map from 'lodash/map';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

interface Props extends AutoCompleteProps {
	users?: Bringg.User[];
}

const renderOption = (user: Bringg.User) => {
	return {
		className: 'users-autocomplete-option',
		value: user.id.toString(),
		label: (
			<>
				<UserAvatarInfo user={user} />
				<div className="users-select-plus-icon">
					<BringgIcon iconName={BringgFontIcons.Plus} />
				</div>
			</>
		)
	};
};

const UsersAutoComplete = (props: Props) => {
	return <AutoComplete {...props} options={_map(props.users, renderOption)} />;
};

export default UsersAutoComplete;
